import { useAuth } from './useAuth';

export const useModuleAccess = () => {
  const { modules } = useAuth();

  return {
    isEnabled: moduleKey => modules?.[moduleKey] === true,
  };
};